import { render, staticRenderFns } from "./c_home_presell.vue?vue&type=template&id=0d8ed2ed&scoped=true&"
import script from "./c_home_presell.vue?vue&type=script&lang=js&"
export * from "./c_home_presell.vue?vue&type=script&lang=js&"
import style0 from "./c_home_presell.vue?vue&type=style&index=0&id=0d8ed2ed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ed2ed",
  null
  
)

export default component.exports